export enum ErrorMessageKey {
  SERVER = 'serverError',
  CLIENT = 'clientError',
  NETWORK = 'networkError',
  UNKNOWN = 'unknownError',
  CHUNK_LOAD_ERROR = 'chunkLoadError',
  BACKUP = 'errorBackup',
}
